import { getEnvironmentConfig } from "~/modules/config/EnvironmentConfig/EnvironmentConfigImpl";
import type { ClientOptionsStore } from "~/modules/client/ClientOptions/ClientOptionsStore";

export function parseRegionForTwilsock(region?: string): string {
    switch (region) {
        case "prod":
        case "":
        case undefined:
        case null:
            return "us1";
        case "stage":
            return "stage-us1";
        case "dev":
            return "dev-us1";
        default:
            return region;
    }
}

type RegionType = "dev" | "stage" | "prod";
export function parseRegionForAnalytics(region?: string): RegionType {
    if (region?.startsWith("dev")) return "dev";
    if (region?.startsWith("stage")) return "stage";
    return "prod";
}

export function buildRegionalHost(region: string): string {
    switch (region) {
        case "prod":
        case "us1":
        case "":
        case undefined:
        case null:
            return "";
        case "dev-us1":
            return ".dev";
        case "stage-us1":
            return ".stage";
        default:
            return `.${region}`;
    }
}

export function buildRegionalHostWithEdge(region: string, edge: string): string {
    const applicableRegion = buildRegionalHost(region);
    let urlRegSpecifier = "";

    if (edge) {
        urlRegSpecifier += `.${edge}`;
    }

    if (applicableRegion) {
        urlRegSpecifier += `${applicableRegion}`;
    }
    return urlRegSpecifier;
}

export function getEnvironmentSuffix(region?: string): string {
    if (!region) {
        return "";
    }
    if (region.startsWith("stage-")) {
        return ".stage";
    }
    if (region.startsWith("dev-")) {
        return ".dev";
    }
    return "";
}

export function getConfigRegion(clientOptions: ClientOptionsStore): string {
    const environmentConfig = getEnvironmentConfig();
    const { region, regionNonFlex } = environmentConfig || {};
    
    return regionNonFlex || clientOptions.regionNonFlex || region || clientOptions.region;
}
